import React, { useState } from 'react';
import styled from 'styled-components';
import MondayIcon from 'monday-ui-react-core/dist/Icon';
import EditIcon from 'monday-ui-react-core/dist/icons/Edit';

const EditButton = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  background-color: black;
  color: white;
  padding: 5px;
  height: 40px;
  border-radius: 5px;
  cursor: pointer;
  overflow: hidden;
  transition: width 0.3s ease, padding-left 0.3s ease;
  width: 40px;
  white-space: nowrap;
  position: absolute;
  right: 0;

  &:hover {
    width: auto;
    padding-left: 15px;
    padding-right: 15px;
  }
`;

const EditFileButton = ({ handleClick }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <EditButton
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={handleClick}
    >
      <MondayIcon
        className="icon"
        iconType={MondayIcon.type.SVG}
        icon={EditIcon}
        iconSize={20}
      />
      {isHovered && <span className="text">Edit Template</span>}
    </EditButton>
  );
};

export default EditFileButton;
